import { render, staticRenderFns } from "./charges-modal.vue?vue&type=template&id=be0f7b6a"
import script from "./charges-modal.vue?vue&type=script&lang=js"
export * from "./charges-modal.vue?vue&type=script&lang=js"
import style0 from "./charges-modal.vue?vue&type=style&index=0&id=be0f7b6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports